module.exports = __webpack_public_path__ + "static/buffalo-0dae9180b61fb142ccee09a1f5f7b309.png";